import Immutable from 'immutable'

// ------------------------------------
// Constants
// ------------------------------------
export const CHANGE_PASSWORD = 'inf/service/CHANGE_PASSWORD'
export const CHANGED_PASSWORD = 'inf/service/CHANGED_PASSWORD'
export const ERROR_PASSWORD = 'inf/service/ERROR_PASSWORD'
export const HIDE_CHANGE_PASSWORD = 'inf/service/HIDE_CHANGE_PASSWORD'
export const SHOW_CHANGE_PASSWORD = 'inf/service/SHOW_CHANGE_PASSWORD'
export const UPDATE_PASSWORD = 'inf/service/UPDATE_PASSWORD'
export const UPDATE_ZXCVBN = 'inf/service/UPDATE_ZXCVBN'

export const constants = {
  CHANGE_PASSWORD,
  CHANGED_PASSWORD,
  ERROR_PASSWORD,
  HIDE_CHANGE_PASSWORD,
  SHOW_CHANGE_PASSWORD,
  UPDATE_PASSWORD,
  UPDATE_ZXCVBN,
}

// ------------------------------------
// Actions
// ------------------------------------
export const changePassword = () => ({
  type: CHANGE_PASSWORD,
})
export const changedPassword = () => ({
  type: CHANGED_PASSWORD,
})
export const errorPassword = errors => ({
  payload: { errors },
  type: ERROR_PASSWORD,
})
export const hideChangePassword = () => ({
  type: HIDE_CHANGE_PASSWORD,
})
export const showChangePassword = serviceId => ({
  payload: { serviceId },
  type: SHOW_CHANGE_PASSWORD,
})
export const updatePassword = (field, password) => ({
  payload: { field, password },
  type: UPDATE_PASSWORD,
})
export const updateZxcvbn = zxcvbn => ({
  payload: { zxcvbn },
  type: UPDATE_ZXCVBN,
})

export const actions = {
  changePassword,
  changedPassword,
  errorPassword,
  hideChangePassword,
  showChangePassword,
  updatePassword,
  updateZxcvbn,
}

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  changed: false,
  changing: false,
  errors: [],
  password: {
    first: '',
    second: '',
  },
  showChangePassword: false,
  serviceId: null,
  zxcvbn: null,
})

export default function reducer(state = initialState, action) {
  const payload = action.payload

  switch (action.type) {
    case CHANGE_PASSWORD:
      return state
        .set('changing', true)
        .set('errors', Immutable.List())

    case CHANGED_PASSWORD:
      return state
        .set('changed', true)
        .set('changing', false)
        .set('errors', Immutable.List())

    case ERROR_PASSWORD:
      return state
        .set('changing', false)
        .set('errors', Immutable.fromJS(payload.errors))

    case HIDE_CHANGE_PASSWORD:
      return initialState

    case SHOW_CHANGE_PASSWORD:
      return initialState
        .set('showChangePassword', true)
        .set('serviceId', payload.serviceId)

    case UPDATE_PASSWORD:
      return state
        .setIn(['password', payload.field], payload.password)

    case UPDATE_ZXCVBN:
      return state
        .set('zxcvbn', payload.zxcvbn)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/service/changePassword.js